import styled from 'styled-components';
import { ApModal, colors } from '@alixpartners/ui-components';

export const StyledModal = styled(ApModal)`
	.ap-modal-lightbox {
		background-color: rgba(50, 50, 50, 0.3);
	}
	.ap-modal-content {
		max-width: 840px;
		border-radius: 1px;
		box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
		max-height: 100%;
		height: 560px;
	}

	.ap-modal-header {
		border-bottom: none;
		padding: 24px 32px 8px 32px;
		h4 {
			font-size: 23px;
			line-height: 31px;
			letter-spacing: 0.3px;
			color: ${colors.grey8};
			font-weight: 500;
		}
		.ap-button-icon {
			position: relative;
			top: -5px;
			right: -14px;
		}
	}

	.ap-modal-footer {
		padding: 6px 32px;
		display: flex;
		${({ isApplying }) => isApplying && 'border-color: transparent;'};

		.ap-button-group {
			margin-left: auto;
		}
	}

	.ap-modal-body {
		padding: 0 0 21px 32px;
		height: 100%;
		overflow: hidden;
	}
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const Content = styled.div`
	display: flex;
	height: 100%;
`;

export const RightSection = styled.div`
	display: flex;
	min-width: 360px;
	width: 360px;
	height: 100%;
	background-color: ${colors.green0};
	padding-top: 16px;
`;

export const MainSection = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	padding-right: 32px;
	flex-direction: column;
	overflow: auto;

	${({ isApplying }) => isApplying && 'overflow: hidden;'};
`;

export const FormGroup = styled.div`
	margin-bottom: 24px;
`;

export const OrangeText = styled.div`
	font-size: 16px;
	line-height: 24px;
	color: ${colors.amber};
`;

export const WarningMessage = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	font-size: 12px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.amber};

	svg {
		margin-right: 10px;
	}
`;

export const Text = styled.div`
	font-size: 16px;
	line-height: 24px;
	color: ${colors.grey8};
	margin-bottom: 16px;
`;

export const Label = styled.div`
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	padding-bottom: 10px;
`;

export const RadioLabelSmall = styled.div`
	font-size: 12px;
	line-height: 14px;
	color: ${colors.grey8};
`;

export const RadioLabel = styled.div`
	font-size: 16px;
	line-height: 24px;
	color: ${colors.grey8};
	padding-left: 3px;
`;

export const RadioGroup = styled.div`
	padding-left: 8px;
	display: flex;
	flex-direction: column;

	> label {
		padding-top: 10px;

		&:first-child {
			padding-top: 0;
		}
	}
`;

export const HorizontalGroup = styled.div`
	display: flex;
	align-items: center;
	padding-left: 8px;

	> span {
		font-size: 13px;
		line-height: 19px;
		letter-spacing: 0.3px;
		color: ${colors.grey5};
	}

	> label,
	> span {
		margin-right: 16px;
	}
`;

export const PreveiwContentWrapper = styled.div`
	padding: 8px 32px 0 0;
	line-height: 24px;
	letter-spacing: 0.3px;
	display: flex;
	flex-direction: column;
	max-height: 100%;
`;

export const VendorsList = styled.ul`
	margin-top: 50px;
	margin-bottom: 16px;
	overflow: auto;
`;

export const VendorsListCell = styled.span`
	width: 100%;
	padding-left: 30px;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	&:first-child {
		padding-left: 0;
		min-width: 220px;
		width: 220px;
	}
`;

export const VendorsListRow = styled.li`
	height: 32px;
	line-height: 32px;
	border-bottom: 1px solid ${colors.grey2};
	display: flex;
`;

export const VendorsListHeader = styled(VendorsListRow)`
	text-transform: uppercase;
	color: ${colors.grey5};
	font-size: 11px;
	letter-spacing: 0.8px;
	height: 21px;
	line-height: 13px;

	${VendorsListCell}:nth-child(3) {
		color: ${colors.green1};
	}
`;

export const ActionableContent = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
`;

export const LoadingWrapper = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	background-color: white;
	z-index: 2;
`;

export const LoadingFooter = styled.div`
	height: 36px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${colors.green1};
	font-size: 13px;
	letter-spacing: 0.3px;
`;
